<template>
  <b-col md="12">
    <button
      :class="[
        'modal-type-card',
        {
          'modal-type-card--with-hover-effect': hasHoverEffect,
          'modal-type-card--is-selected': isSelected,
        },
      ]"
      @click="() => $emit('click')"
    >
      <!-- TODO: add icon when it's ready -->
      <i v-if="false" :class="icon"></i>
      <div>
        <p class="modal-type-card__title">{{ title }}</p>
        <p class="modal-type-card__description mb-0">{{ description }}</p>
      </div>
    </button>
  </b-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    hasHoverEffect: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.modal-type-card {
  width: 100%;
  background: white;
  text-align: left;
  padding: 12px;
  border: 1px solid rgba(235, 236, 239, 1);
  border-radius: 8px;

  display: flex;
  gap: 12px;

  i {
    font-size: 20px;
  }

  &--with-hover-effect {
    &:hover {
      background-color: $mep-color-text-100;
    }
  }

  &--is-selected {
    background-color: $mep-color-text-100;
  }

  &__title {
    font-weight: 600;
    margin-bottom: 4px;
    color: $mep-color-text;
  }
  &__description {
    color: $mep-color-text-300;
  }
}
</style>
